import { colors } from '../colors'

export const bluePalette = {
  text: {
    primary: colors.text,
  },
  primary: {
    contrastText: colors.white,
    light: colors.blueLight,
    main: colors.blue,
  },
  secondary: {
    contrastText: colors.white,
    dark: '#7c1310',
    main: '#e43631',
  },
}
